import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=42920498&"
import script from "./Section3.vue?vue&type=script&lang=js&"
export * from "./Section3.vue?vue&type=script&lang=js&"
import style0 from "./Section3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports